// Metric row for the admin overview: label, mono value, optional sub-line.
// Upstream: shadcn-ui/ui apps/v4/registry/new-york-v4/blocks/dashboard-01/components/section-cards.tsx — MIT (gradient removed, no big-number tile).

import type { ReactNode } from "react";
import { Card } from "@/ui";

export function StatCard({
  label,
  value,
  sub,
}: {
  label: string;
  value: ReactNode;
  sub?: ReactNode;
}) {
  return (
    <Card className="gap-1">
      <p className="text-sm text-fg-2">{label}</p>
      <p className="font-mono text-2xl text-fg-0 tabular-nums">{value}</p>
      {sub && <p className="text-sm text-fg-2">{sub}</p>}
    </Card>
  );
}
